import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderControl,
  CardTitle,
  Link,
  StatusBadge,
} from '@apollo/orbit';
import classnames from 'classnames';
import { capitalize } from 'lodash';
import React from 'react';

import { GraphRef, graphRefToString } from 'src/app/graph/hooks/useGraphRef';
import { explorerRouteConfig } from 'src/app/graph/routes';
import {
  getAction,
  getBody,
  getColorScheme,
  getTransitionStateTitle,
  getTransitionStateTitleClassname,
} from 'src/app/graph/variantsHomepage/cloudRouterDetails/helpers';
import { CloudTier, RouterStatus } from 'src/lib/graphqlTypes/types';

export const RouterHealthCard = ({
  status,
  nextStatus,
  graphRef,
  endpoint,
  isInitiating,
  tier,
}: {
  status?: RouterStatus;
  nextStatus?: RouterStatus;
  graphRef: GraphRef;
  endpoint?: string;
  isInitiating: boolean;
  tier?: CloudTier;
}) => {
  const colorScheme = getColorScheme(status, nextStatus);
  const transitionStateTitle = getTransitionStateTitle(nextStatus);
  const transitionStateTitleClassname =
    getTransitionStateTitleClassname(nextStatus);
  const body = getBody(status, nextStatus);
  const action = getAction(status, nextStatus);

  return (
    <Card isDivided className="mb-4 md:mb-0 lg:mr-6">
      <CardHeader>
        <CardTitle>Router status</CardTitle>
        <CardHeaderControl>
          <StatusBadge variant="hidden" colorScheme={colorScheme}>
            {isInitiating ? 'Initiating' : (capitalize(status) ?? '')}
          </StatusBadge>
        </CardHeaderControl>
      </CardHeader>
      <CardBody>
        {tier && (
          <div className="gap-0">
            <div className="text-heading-xl">Tier</div>
            <div>{capitalize(tier)}</div>
          </div>
        )}
        {transitionStateTitle && (
          <p
            className={classnames(
              'font-semibold',
              // eslint-disable-next-line local/no-conditional-class-names
              transitionStateTitleClassname,
            )}
          >
            {transitionStateTitle}
          </p>
        )}
        {body && <p>{body}</p>}
        <p>
          {status !== 'DELETED' && endpoint && (
            <>
              <span className="font-semibold">
                {graphRefToString(graphRef)}
              </span>
              's router is hosted @:
              <Link
                className="ml-1 truncate text-wrap"
                isExternal
                to={endpoint}
              >
                {endpoint}
              </Link>
            </>
          )}
        </p>
        {action && (
          <Link
            to={explorerRouteConfig.location({
              ...graphRef,
            })}
            className="text-body-sm-sb"
          >
            {action}
          </Link>
        )}
      </CardBody>
    </Card>
  );
};
